import {
  ActionTypes,
  AddSelectedPromotion,
  ChangePage,
  ClearPromotions,
  FetchPromotionsFailAction,
  FetchPromotionsStartAction,
  FetchPromotionsSuccessAction,
  ResetPromotionsState,
  SetRetailerPromotionOrder,
  SetSelectedPromotion,
} from './types';

import { NextPromotion, RetailerPromotionOrder } from '@/types/promotion';

const fetchPromotionsStart = (): FetchPromotionsStartAction => ({
  type: ActionTypes.FETCH_PROMOTIONS_START,
});

const fetchPromotionsSuccess = (payload: [], totalItems: number): FetchPromotionsSuccessAction => ({
  type: ActionTypes.FETCH_PROMOTIONS_SUCCESS,
  payload,
  totalItems,
});

const addSelectedPromotion = (payload: NextPromotion): AddSelectedPromotion => ({
  type: ActionTypes.ADD_SELECTED_PROMOTION,
  payload,
});

const fetchPromotionsFail = (payload: string): FetchPromotionsFailAction => ({
  type: ActionTypes.FETCH_PROMOTIONS_FAIL,
  payload,
});

const changePage = (payload: number): ChangePage => ({
  type: ActionTypes.CHANGE_PAGE,
  payload,
});

const setSelectedPromotion = (payload: NextPromotion | undefined): SetSelectedPromotion => ({
  type: ActionTypes.SET_SELECTED_PROMOTION,
  payload,
});

const setRetailerPromotionOrder = (payload: RetailerPromotionOrder[] | []): SetRetailerPromotionOrder => ({
  type: ActionTypes.SET_PROMOTION_RETAILER,
  payload,
});

const clearPromotions = (): ClearPromotions => ({
  type: ActionTypes.CLEAR_PROMOTIONS,
});

const resetPromotionsState = (): ResetPromotionsState => ({
  type: ActionTypes.RESET_PROMOTIONS_STATE,
});

export {
  fetchPromotionsStart,
  fetchPromotionsSuccess,
  fetchPromotionsFail,
  changePage,
  addSelectedPromotion,
  setSelectedPromotion,
  setRetailerPromotionOrder,
  clearPromotions,
  resetPromotionsState,
};
